<div class="sgt-pedido-clicheria-status-multiselect">
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="idsStatusClicheria"
        (ngModelChange)="onSelectionChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>
